import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {
	return {

		viewAllChip: {
			backgroundColor : theme.other.paletteNew.darkModeInclinedBlack1,
			border          : `3px solid ${ theme.other.paletteNew.darkModeDarkGrey20 }`,
			display         : "flex",
			width           : "fit-content",
			cursor          : "pointer",
			padding         : "0 1rem",
			justifyContent  : "center",
			alignItems      : "center",
			borderRadius    : "5rem"
		},
		avatarPlaceholder: {
			background: "none"
		},
		caretIcon: {
			position : "relative",
			bottom   : "1px"
		},
		headerWrapper: {
			display       : "flex",
			flexDirection : "column",
			position      : "sticky",
			borderBottom  : !theme.other.darkMode ? `1px solid ${ theme.other.colors.border.primary }` : "1px solid transparent",
			background    : theme.other.colors.dialog.primary,
			top           : 0
		},
		headerTop: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			padding        : "1.5rem",
			paddingBottom  : "0.8rem",
			borderRadius   : "1rem 1rem 0 0",

			[rooterMediaQuery.mobile]: {
				borderRadius: "0"
			}
		},
		closeIconWrapper: {
			height      : "unset",
			marginRight : "1rem"
		},

		// popover styles
		popoverDropdown: {
			height        : "100%",
			minHeight     : "50vh",
			background    : !theme.other.darkMode ? theme.other.paletteNew.secondaryWhite : theme.other.paletteNew.darkModeInclinedBlack2,
			flexBasis     : "auto",
			borderRadius  : "1rem",
			boxShadow     : "none",
			maxHeight     : "60vh",
			width         : "400px !important",
			overflow      : props?.from === "profile" ? "hidden !important" : "auto",
			display       : "flex",
			flexDirection : "column",
			// position     : "relative"

			// only add rotating border if it is opened from profile
			...( props?.from === "profile" &&
			{ padding  : "0.1rem",
				":after" : {
					content         : "' '",
					position        : "absolute",
					left            : "50%",
					top             : "50%",
					height          : "1200px",
					width           : "1200px",
					backgroundImage : theme.other.paletteNew.proChipGradient,
					zIndex          : "-1",
					transform       : "translate(-50%, -50%)",
					animation       : "rotateProChip 10s linear infinite",

					"@keyframes rotateProChip": {
						"0%": {
							transform: "translate(-50%, -50%) rotate(0deg)"
						},
						"100%": {
							transform: "translate(-50%, -50%) rotate(360deg)"
						}
					}
				} } )
		},
		modalBody: {
			display       : "flex",
			flexDirection : "column",
			overflow      : "auto",
			height        : "100%",
			padding       : "0rem !important",
			borderRadius  : "1rem"
		},
		popoverHeader: {
			flex    : "1",
			padding : "0.5rem"
		},
		loaderWrapper: {
			minHeight      : "45vh",
			display        : "flex",
			justifyContent : "center",
			alignItems     : "center"
		},
		// list styles
		content: {
			flex          : "1",
			overflow      : "auto",
			display       : "flex",
			flexDirection : "column",
			borderRadius  : "0 0 1rem 1rem",
			background    : !theme.other.darkMode ? theme.other.paletteNew.secondaryWhite : theme.other.paletteNew.darkModeInclinedBlack2
		},
		listRoot: {
			listStyleType: "none"
		},
		listItem: {
			padding      : "1rem 2rem",
			paddingRight : "0"
		},
		listItemWrapper: {
			width: "100%"
		},
		listItemContent: {
			display    : "flex",
			gap        : "1rem",
			alignItems : "center"
		},
		userImg: {
			aspectRatio  : "1/1",
			width        : "4rem",
			height       : "4rem",
			borderRadius : "50%"
		},
		nameWrapper: {
			textOverflow : "ellipsis",
			overflow     : "hidden",
			display      : "flex",
			alignItems   : "center",
			gap          : "0.5rem"
		},
		listItemRight: {
			overflow       : "hidden",
			display        : "flex",
			justifyContent : "space-between",
			flex           : "1",
			padding        : "1rem 1rem 1.5rem 0.4rem",
			borderBottom   : `1px solid ${ theme.other.colors.border.primary }`,
			gap            : "1rem"

		},
		listText: {
		},
		followBtn: {
			background : theme.other.paletteNew.proGradient,
			minWidth   : "10rem"
		},
		unfollow: {
			background: theme.other.colors.primaryBtn.clicked.background
		},
		proButtonChip: {
			border   : "none",
			padding  : "0.1rem !important",
			overflow : "hidden",
			position : "relative",
			":after" : {
				content         : "' '",
				position        : "absolute",
				left            : "50%",
				top             : "50%",
				height          : "140px",
				width           : "140px",
				backgroundImage : theme.other.paletteNew.proChipGradient,
				zIndex          : "0",
				transform       : "translate(-50%, -50%)",
				animation       : "rotateProChip 3s linear infinite",

				"@keyframes rotateProChip": {
					"0%": {
						transform: "translate(-50%, -50%) rotate(0deg)"
					},
					"100%": {
						transform: "translate(-50%, -50%) rotate(360deg)"
					}
				}
			}
		},
		proChipContentStyles: {
			position     : "relative",
			zIndex       : "1",
			background   : `${ theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack1 : theme.other.paletteNew.secondaryLightGrey }!important`,
			padding      : "0 1.5rem",
			borderRadius : "1rem"
		},
		searchInput: {
			padding      : "1rem",
			borderWidth  : "0",
			height       : "unset",
			borderRadius : "1rem"
		},
		searchInputWrapper: {
			margin          : "1rem",
			backgroundColor : theme.other.colors.input.primary
			// backgroundColor : theme.other.paletteNew.secondaryWhite
		},
		searchIcon: {
			height : "15px",
			width  : "15px"
		},
		inputRoot: {
			padding         : "2rem",
			backgroundColor : !theme.other.darkMode ? theme.other.paletteNew.secondaryWhite : theme.other.paletteNew.darkModeInclinedBlack2
		},
		input: {
			backgroundColor : theme.other.colors.input.primary,
			border          : "1px solid transparent",
			borderRadius    : "1rem",
			padding         : "2rem",
			transition      : "border 0.1s ease-in-out",
			":focus"        : {
				border: `1px solid ${ theme.other.paletteNew.primaryDarkBlue }`
			},
			"&[data-invalid]": {
				border: `1px solid ${ theme.other.paletteNew.tertiaryErrorRed }`
			}
		},
		inputWrapper: {
			marginBottom    : "0",
			borderRadius    : "1rem",
			backgroundColor : theme.other.colors.input.primary
		},
		drawerBody: {
			display       : "flex",
			flexDirection : "column",
			height        : "100%"
		}
	};
} );